import { PharmacyBarcodeReader } from "./CAH_barcode_reader";
import { ExternalVendorPackingListReader } from "./other_vendor_barcode_reader";

export class BarcodeReader {

    readers: any = [];

    constructor() {
        this.readers.push(new PharmacyBarcodeReader());
        this.readers.push(new ExternalVendorPackingListReader());
    }

    register(strategy) {
        this.readers.push(strategy);
    }

    decode(content) {
        var reader = this.getReader(content)
        if (reader) {
            return reader.decode(content);
        }
        return { type: "Unknown", barcode: content };;
    }

    getReader(content) {
        var reader = null; // Need default
        for (var i = 0; i < this.readers.length; i++) {
            if (this.readers[i].canDecode(content)) {
                reader = this.readers[i];
                break;
            }
        }
        return reader;
    }


}